import { z } from '@framework/zod';

const numericString = z
  .string()
  .transform((val) => val.replace(',', '.'))
  .pipe(
    z.string().refine(
      (val) => val === '' || (!Number.isNaN(Number(val)) && /\d$/.test(val)),
      'Please enter a valid number',
    ),
  );

export { numericString };
